export default [
  {
    name: '/personal-center/payment-manage',
    path: '/personal-center/payment-manage',
    component: (resolve) => require(['@/views/personal-center/payment/Index.vue'], resolve),
    meta: {
      pageId: 'personal_paymentManage'
    }
  }, {
    name: '/personal-center/address-manage',
    path: '/personal-center/address-manage',
    component: (resolve) => require(['@/views/personal-center/address/Index.vue'], resolve),
    meta: {
      pageId: 'personal_addressManage'
    }
  }, {
    name: '/personal-center/add-address/',
    path: '/personal-center/add-address',
    component: (resolve) => require(['@/views/personal-center/address/MobileAddAddress.vue'], resolve),
    meta: {
      pageId: 'personal_addAddress'
    }
  }, {
    name: '/personal-center/store-manage',
    path: '/personal-center/store-manage',
    component: (resolve) => require(['@/views/personal-center/store/Index.vue'], resolve),
    meta: {
      pageId: 'personal_store'
    }
  }, {
    name: '/personal-center/store-setting',
    path: '/personal-center/store-setting',
    component: (resolve) => require(['@/views/personal-center/store/SetStore.vue'], resolve),
    meta: {
      pageId: 'personal_storeSetting'
    }
  }, {
    name: '/personal-center/account-setting',
    path: '/personal-center/account-setting',
    component: (resolve) => require(['@/views/personal-center/account-setting/Index.vue'], resolve),
    meta: {
      pageId: 'personal_accountSetting'
    }
  }, {
    name: '/personal-center/my-information',
    path: '/personal-center/my-information',
    component: (resolve) => require(['@/views/personal-center/my-information/Index.vue'], resolve),
    meta: {
      pageId: 'personal_information'
    }
  },
  // 优惠券列表
  {
    name: '/personal-center/coupons',
    path: '/personal-center/coupons',
    component: (resolve) => require(['@/views/personal-center/coupons/index.vue'], resolve),
    meta: {
      pageId: 'personal_coupons'
    }
  },
  // api设置
  {
    name: '/personal-center/api-setting',
    path: '/personal-center/api-setting',
    component: (resolve) => require(['@/views/personal-center/api-setting/index.vue'], resolve),
    meta: {
      pageId: 'personal_apiSetting'
    }
  }
]
